export default {
  facts(state) {
    return state.facts;
  },
  totalFacts(state) {
    return state.totalFacts;
  }
};
